<template>
    <div class="authentication-method-line-component">
        <b-button size="lg" block variant="bare-dark" :href="loginUrl" class="auth-method-line-button">
            <div class="d-flex gap-3 align-items-center justify-content-between">
                <div class="font-weight-bold text-left">{{ title }}</div>
                <div class="">  <!-- height: 50px; max-width: 100px; -->
                    <!-- set a fixed height on the image (or wrapper) so your auto height adjuster thing still works, otherwise it gets thrown off when the images load -->
                    <b-img v-if="logo" :src="logo" height="40" width="80" :alt="`Login using ${title}`" style="object-fit: contain; object-position: right;"></b-img>  <!-- style="max-width: 70px;"  style="max-width: 100%; height: auto;" -->
                </div>
            </div>
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'AuthenticationMethodLine',
    components: {},
    props: {
        title: {
            type: String,
            default: "Login using default method",
        },
        loginUrl: {
            type: String,
            default: '/accounts/login',
        },
        logo: {
            required: false,
            type: String,
        },
    },
}
</script>

<style lang="scss">
.authentication-method-line-component {
    .auth-method-line-button {
        padding: 0.75rem 1rem;  // normal btn-lg is 0.5rem 1.5rem;
        border: 1px solid var(--gray-300);
        background-color: #ffffff;
        &:hover {
            border: 1px solid var(--primary);
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
        }
    }
}
</style>
